import { processLoggers } from './config.js';

var enhancerMap = {};

var loggingEnhancer = function loggingEnhancer() {
  return function (createStore) {
    return function (reducer, initialState) {
      var enhancerReducer = reducer;

      var loggingReducer = function loggingReducer(state, action) {
        // apply any new enhancer reducers
        processLoggers(function (logger) {
          if (!enhancerMap[logger.type] && logger.getEnhancer) {
            var en = logger.getEnhancer();

            if (en) {
              var next = function next(r) {
                enhancerReducer = r;
              };

              var createdStore = en(next);
              createdStore(enhancerReducer);
              enhancerMap[logger.type] = createdStore;
            }
          }
        });
        return enhancerReducer(state, action);
      };

      return createStore(loggingReducer, initialState);
    };
  };
};

var loggingEnhancer$1 = loggingEnhancer;

export { loggingEnhancer$1 as default };
